import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=b837bab0&scoped=true&"
import script from "./EditInfo.vue?vue&type=script&lang=tsx&"
export * from "./EditInfo.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b837bab0",
  null
  
)

export default component.exports